const ArrowDownIcon = ({ className = '', width = '100%', height = '100%' }) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 8 6">
      <path d="M7.06 0.333328L4 3.62977L0.94 0.333328L0 1.34817L4 5.66666L8 1.34817L7.06 0.333328Z" />
    </svg>
  );
};

export default ArrowDownIcon;
